// Constants
export const APP_NAME = 'n8n Builder';
export const API_VERSION = 'v1';
export const SUBSCRIPTION_TIERS = ['free', 'pro', 'business'];
// Credit allocation per tier
export const TIER_CREDITS = { free: 5, pro: 150, business: 450 };
export const TIER_MAX_CREDITS = { free: 10, pro: 300, business: 900 };
// Polar production product IDs
export const POLAR_PRODUCT_IDS = {
    pro: 'b3623f3d-940d-4a1e-8430-3e1375e23d89',
    business: '39277cda-18c3-4afb-b927-b907f33d3213',
};
// Reverse lookup: product ID → tier
export const PRODUCT_ID_TO_TIER = {
    'b3623f3d-940d-4a1e-8430-3e1375e23d89': 'pro',
    '39277cda-18c3-4afb-b927-b907f33d3213': 'business',
};
// Tier display info
export const TIER_INFO = {
    free: { name: 'Free', price: 0, description: 'No active subscription' },
    pro: { name: 'Pro', price: 34, description: '150 credits/month for regular use' },
    business: { name: 'Business', price: 67, description: '450 credits/month for power users' },
};
// Tier-gated feature limits
export const TIER_LIMITS = {
    free: { maxInstances: 0, allowedModels: ['sonnet-4.5', 'haiku-4.5'] },
    pro: { maxInstances: 1, allowedModels: ['sonnet-4.5', 'haiku-4.5'] },
    business: { maxInstances: Infinity, allowedModels: ['sonnet-4.5', 'haiku-4.5', 'opus-4.5'] },
};
export function isModelAllowed(tier, model) {
    return TIER_LIMITS[tier]?.allowedModels?.includes(model) ?? false;
}
export function getMaxInstances(tier) {
    return TIER_LIMITS[tier]?.maxInstances ?? 0;
}
// Validation helpers
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
export function isValidUrl(url) {
    try {
        new URL(url);
        return true;
    }
    catch {
        return false;
    }
}
export function isValidN8nApiKey(key) {
    // n8n API keys typically start with 'n8n_api_'
    return key.startsWith('n8n_api_') && key.length > 20;
}
// Utility functions
export function generateId() {
    return crypto.randomUUID();
}
export function slugify(text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}
export function truncate(text, maxLength) {
    if (text.length <= maxLength)
        return text;
    return text.slice(0, maxLength - 3) + '...';
}
//# sourceMappingURL=index.js.map